import { render, staticRenderFns } from "./BaseNavigation.vue?vue&type=template&id=3e08e58e&"
import script from "./BaseNavigation.vue?vue&type=script&lang=ts&"
export * from "./BaseNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports